
import javaApi from './javaApi'

const ALL_API = Object.assign(javaApi)

export default ALL_API
